const API_BASE = "/api/foca";

export class HttpError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(
  method: string,
  path: string,
  body?: unknown,
  init?: RequestInit
): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json", ...(init?.headers || {}) } : init?.headers,
    body: body ? JSON.stringify(body) : undefined,
    ...init,
  });

  if (res.status === 204) return undefined as T;

  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await res.json() : await res.text();

  if (!res.ok) {
    const message = typeof data === "object" && data && "message" in data
      ? String((data as { message: unknown }).message)
      : `HTTP ${res.status}`;
    throw new HttpError(res.status, message);
  }

  return data as T;
}

export const api = {
  get:   <T>(path: string, init?: RequestInit) => request<T>("GET",    path, undefined, init),
  post:  <T>(path: string, body?: unknown)     => request<T>("POST",   path, body),
  patch: <T>(path: string, body?: unknown)     => request<T>("PATCH",  path, body),
  put:   <T>(path: string, body?: unknown)     => request<T>("PUT",    path, body),
  delete:<T>(path: string)                     => request<T>("DELETE", path),
};
